export default "__VITE_ASSET__eb5d2354__"